import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-body py-4 px-lg-6 umt-form" }
const _hoisted_2 = { class: "d-flex gap-5" }
const _hoisted_3 = { class: "fv-row" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold required w-100 text-start" }, "Gửi email mẫu", -1)
const _hoisted_5 = { class: "fv-row" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold text-white" }, ".", -1)
const _hoisted_7 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
    model: _ctx.formData,
    ref: "formRef"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_el_input, {
              type: "text",
              class: "mb-2",
              name: "email",
              modelValue: _ctx.formData.email,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.email) = $event)),
              placeholder: "Nhập email"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("button", {
              class: "btn btn-primary m-auto",
              disabled: _ctx.formData.email=='',
              type: "submit"
            }, " Gửi ", 8, _hoisted_7)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["model"]))
}